module.exports = __webpack_public_path__ + "static/media/person8.096d0b1f.svg";